import { EAccountPlansType } from "../../Enum/EAccountPlansType"
import { EBillingPeriodType } from "../../Enum/EBillingPeriodType"
import { EPaymentProcessingSeverityType } from "../../Enum/EPaymentProcessingSeverityType"

export class SubscriptionBillingStatus {
  companyId: number

  companyName: string

  planType: EAccountPlansType

  subscriptionStatus: string

  lastPaymentStatus: string

  lastPaymentAmount?: number

  lastPaymentDate?: Date

  currentChargeAmount: number

  periodType?: EBillingPeriodType

  nextPaymentDate?: Date

  pendingRenewalChargeId?: number

  processingSeverity: EPaymentProcessingSeverityType

  canRequestSupport: boolean

  averageProcessingTimeText: string

  isActionBlocked: boolean

  constructor(data: Partial<SubscriptionBillingStatus> = {}) {
    this.companyId = data.companyId ?? 0

    this.companyName = data.companyName ?? ""

    this.planType = data.planType ?? EAccountPlansType.None

    this.subscriptionStatus = data.subscriptionStatus ?? "none"

    this.lastPaymentStatus = data.lastPaymentStatus ?? ""

    this.lastPaymentAmount = data.lastPaymentAmount

    this.lastPaymentDate = data.lastPaymentDate ? new Date(data.lastPaymentDate) : undefined

    this.currentChargeAmount = data.currentChargeAmount ?? 0

    this.periodType = data.periodType

    this.nextPaymentDate = data.nextPaymentDate ? new Date(data.nextPaymentDate) : undefined

    this.pendingRenewalChargeId = data.pendingRenewalChargeId

    this.processingSeverity = data.processingSeverity ?? EPaymentProcessingSeverityType.None

    this.canRequestSupport = data.canRequestSupport ?? false

    this.averageProcessingTimeText = data.averageProcessingTimeText ?? ""

    this.isActionBlocked = data.isActionBlocked ?? false
  }
}
